/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit';

export class ConnectSourceAwsOrganizationalUnitResponse {
  'organizationalUnit': SourceAwsOrganizationalUnit;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizationalUnit",
      "baseName": "organizationalUnit",
      "type": "SourceAwsOrganizationalUnit",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectSourceAwsOrganizationalUnitResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

